// extracted by mini-css-extract-plugin
export default {"toggleVideo":"ToggleVideo_toggleVideo__lPDgo","videoBackground":"ToggleVideo_videoBackground__YpE3y"};